import { useContext, useState } from "react";
import axios from "../axios";
import { toast } from "sonner";
import { RmcContext } from "../../components/context/RmcContext";

export const useGetAudience = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const { setRmcAudience } = useContext(RmcContext);

  const GetAudience = async (branId, isArena) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `/audiences/get-profile?is_arena=${isArena}&brand_id=${branId}`,
      );

      if (res.status === 200) {
        setLoading(false);
        if (isArena) {
          setData(res?.data);
        } else {
          setRmcAudience(res?.data);
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return { GetAudience, loading, data };
};
